var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics container"},[_c('div',{staticClass:"top_info"}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"data"},[_c('div',{staticClass:"circle"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ..._vm.$route.query,
                type: 'video',
              },
            })}}},[_c('p',{staticClass:"title"},[_vm._v("视频数据")]),_c('b',[_vm._v(_vm._s(_vm.statisticsinfo.videoRate)+" %")])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ..._vm.$route.query,
                type: 'ppt',
              },
            })}}},[_c('p',{staticClass:"title"},[_vm._v("PPT数据")]),_c('b',[_vm._v(_vm._s(_vm.statisticsinfo.pptRate)+" %")])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ..._vm.$route.query,
                type: 'test',
              },
            })}}},[_c('p',{staticClass:"title"},[_vm._v("考核数据")]),_c('b',[_vm._v(_vm._s(_vm.statisticsinfo.testRate)+" %")])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ..._vm.$route.query,
                type: 'works',
              },
            })}}},[_c('p',{staticClass:"title"},[_vm._v("实战数据")]),_c('b',[_vm._v(_vm._s(_vm.statisticsinfo.szRate)+" %")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }